import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowDropUp = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M377-400q-27 0-37.5-24.5T348-468l104-104q6-6 13-9t15-3 15 3 13 9l104 104q19 19 8.5 43.5T583-400z" })));
const ForwardRef = forwardRef(SvgArrowDropUp);
const Memo = memo(ForwardRef);
export default Memo;
